import { all, put } from 'redux-saga/effects';

import { selectWhen } from 'store/helpers';
import * as InsuranceAnketaActions from 'store/insuranceAnketa/actions';
import { backToFrontCustomer } from 'store/insuranceAnketa/backToFrontMapper';
import * as InsuranceAnketaConstants from 'store/insuranceAnketa/constants';
import * as InsuranceAnketaSelectors from 'store/insuranceAnketa/selectors';

import * as InsuranceConstants from '../../constants';
import { aggregateCustomerIDsByRole, CreateStage } from '../../helpers';

const isValidCustomers = (customers) => {
  return Array.isArray(customers) && customers.length;
};

export const insuranceStageGetOwnerCustomer = new CreateStage({
  action: InsuranceConstants.ACTIONS.GET_OWNER_CUSTOMER,
  handler: function* () {
    const [roles, customers] = yield all([
      selectWhen(
        InsuranceAnketaSelectors.selectField(InsuranceAnketaConstants.FIELDS.CUSTOMER_ROLES),
        Boolean
      ),
      selectWhen(
        InsuranceAnketaSelectors.selectField(InsuranceAnketaConstants.FIELDS.FILLED_CUSTOMERS),
        isValidCustomers
      ),
    ]);

    const {
      [InsuranceAnketaConstants.CUSTOMER_ROLES.DRIVER]: driverMap,
      [InsuranceAnketaConstants.CUSTOMER_ROLES.OWNER]: ownerMap,
    } = aggregateCustomerIDsByRole({ roles });
    const { value: ownerCustomerId } = ownerMap.keys().next();

    const customer = customers.find(({ id }) => {
      return String(id) === ownerCustomerId;
    });

    if (!customer) {
      return;
    }

    yield put(
      InsuranceAnketaActions.setBatchState({
        ...backToFrontCustomer({ customer }),
        // Собственник будет водителем только если есть роль
        [InsuranceAnketaConstants.FIELDS.OWNER_IS_DRIVER]: driverMap.has(ownerCustomerId),
      })
    );
  },
  name: InsuranceConstants.STAGES_FIELDS.GET_OWNER_CUSTOMER,
}).watcher;
